// extracted by mini-css-extract-plugin
module.exports = {"container":"description_container__2HSDe"};